module.exports = __webpack_public_path__ + "static/img/3areaB_11.a84aa48.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_11.png
// module id = 1153
// module chunks = 1